module.exports = __webpack_public_path__ + "img/product_85.55bc236.webp";